import  * as UserFacts from "@ms-ofb/officepersonalization/dist/lib/Facts/UserFacts";

export function sendUserFact(userFactName: string): void {
    UserFacts.processUserFactEvent(userFactName, new Date());
}
